// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/resultoverall.scss
// module id = 357
// module chunks = 2